export default {
    data() {
        return {
            stripeMixin: {
                loading: false,
            }
        }
    },

    methods: {
        // Allows creating a customer portal, with specific data (or empty for general management)
        createCustomerPortal(data = {}) {
            this.stripeMixin.loading = true;
            return this.axios.post('/billing/customer-portal-session', data).then((res) => {
                window.location.href = res.data.url;
            }).finally(() => {
                this.stripeMixin.loading = false;
            })
        }
    }
}
